<template>
  <div id="stats-table" class="data-table">
    <div class="header">
      <div>Skill</div><div>Hours Needed</div><div>Cap 7d%</div><div>Cap 7d - pro%</div><div>Cap 3d%</div><div>Operator</div><div>Pros</div>
    </div>
    <div v-for="row in rows" v-bind:key="row.id" class="row">
      <div class="cell" style="text-align:left;padding-left: 30px">
        <router-link style="display:block" :to="{ name: 'citySkillPage', params: { id: row.skillId, city: row.cityCode }}">
          {{row.cityCode.charAt(0).toUpperCase() + row.cityCode.slice(1) + ', ' +skills[row.skillId].localizedTitle['lt']}}
        </router-link>
      </div>
      <div class="cell">{{Math.round(row.hoursEstimated7d)}}</div>
      <div class="cell" :style="getCap7dStyles(row.capacityPercentage7d)">{{row.capacityPercentage7d}}%</div>
      <div class="cell" :style="getCap7dMinusProStyles(row.capacityPercentage7dWithoutTopPro)">{{row.capacityPercentage7dWithoutTopPro}}%</div>
      <div class="cell" :style="getCap3dStyles(row.capacityPercentage3d)">{{row.capacityPercentage3d}}%</div>
      <div class="cell" style="color:maroon">{{row.operatorTimesVisible ? 'TRUE' : ''}}</div>
      <div class="cell">{{row.numProsAvailable}}</div>
    </div>
  </div>
</template>

<style scoped lang="less">
#stats-table{
  grid-template-columns: auto auto auto auto auto auto auto;
}
</style>

<script>

export default {
  name: 'capacity',
    data: function() {
    return {
      skills: [],
      rows: []
    }
  },
  methods: {
    getCap7dStyles(num) {
      if (num < 100) {
        return 'color:#d41a0d; font-weight: bold'
      } else if (num < 300) {
        return 'color:#d4a50d; font-weight: bold'
      } else return '';
    },
    getCap7dMinusProStyles(num) {
      if (num < 100) {
        return 'color:#d4a50d; font-weight: bold'
      } else return '';
    },
    getCap3dStyles(num) {
      if (num < 80) {
        return 'color:#d4a50d; font-weight: bold';
      } else {
        return '';
      }
    }
  },
  created: async function() {
    // console.log(translations['skill.electricalInstallation.title']);
    const skills = this.$store.state.skills;
    const rows = [];
    Object.keys(skills).forEach(s => {
      const skill = skills[s];
      const capacity = skill.b2bCapacity || {};
      const cities = Object.keys(capacity);
      cities.forEach(city => {
        rows.push({
          skillId: s,
          cityCode: city,
          id: s + city,
          ...capacity[city]
        })
      });
    });
    this.skills = skills;
    this.rows = rows.sort((r1, r2) => {return r2.hoursEstimated7d - r1.hoursEstimated7d});
  }
}
</script>
